import * as React from 'react';
import { useState } from 'react';
import { Element } from 'react-scroll/modules';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import SrInfo from './srInfo';
import SrTab from './srTab';
import SrWarning from './srWarning';
import TestGuideHeader from '../testGuideHeader';
import { Module } from '@domain/constant/acca/test/result/moduleType';
import classNames from 'classnames/bind';
import styles from './srGuide.module.scss';

const cx = classNames.bind(styles);

const SrGuide = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const { accaResultStore } = useResultStore();
  const { accApplyResult } = accaResultStore;

  if (!accApplyResult) return null;

  const moduleResult = accApplyResult.moduleResults?.find((moduleResult) => moduleResult.module === Module.SELF_REPORT);
  const unreliableYn = moduleResult?.unreliableYn;

  return (
    <Element name={Module.SELF_REPORT} className={cx('testGuideWrap')}>
      <div className={cx('testGuideWrap')}>
        <TestGuideHeader moduleType={Module.SELF_REPORT} />

        <div className={cx('contentWrap')}>
          <div className={cx('contentBox')}>
            {/* [D] 경고 영역 */}
            {unreliableYn && <SrWarning />}

            {/* [D] 탭 영역 */}
            <SrTab menu={'LIKERT'} tabIndex={tabIndex} setTabIndex={setTabIndex} />

            {/* [D] 설명 영역 */}
            <SrInfo menu={'LIKERT'} tabIndex={tabIndex} />
          </div>
        </div>
      </div>
    </Element>
  );
};

export default SrGuide;
